import { Button } from "@material-ui/core";
import { EditOutlined } from "@material-ui/icons";

export default function FinancialCardActions({ editableLinks, onEdit }) {

    if (!editableLinks.length) return null;

    return (
        <Button variant="outlined" color="primary" size="small" startIcon={<EditOutlined />} onClick={onEdit}>
            Editar valores
        </Button>
    );
}
